import PropTypes from "prop-types";

const GroupPermissionsPropType = PropTypes.shape({
  updateGroupAttributes: PropTypes.bool,
  __typename: PropTypes.string,
});

export default GroupPermissionsPropType;
